import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';

// App components
import Header from './Header';
import Home from './Home';
import About from './About';
import Teachers from './Teachers';
import Courses from './Courses';
import NotFound from './NotFound';
import Featured from './Featured';

const App = () => (
  <BrowserRouter>
    <div className="container">
      <Header />

      <Route path="http://alanmcclenaghan.com/react/course-directory/" component={Home} />

      <Switch>
        <Route exact path="/" component={Home} />
        { /* The render prop lets you do inline component rendering.
        One of the main reasons you'd want to use render over  component  is when you need to pass props to the component you're rendering. */}
        <Route path="/about" render={() => <About title='About' />} />
        <Route exact path="/teachers" component={Teachers} />
        <Route path="/teachers/:topic/:name" component={Featured} />
        <Route path="/courses" component={Courses} />
        <Route component={NotFound} />
      </Switch>
    </div>
  </BrowserRouter>

);

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js